import { createAction, props } from '@ngrx/store';

import type { CellarData } from '@app/types/cellar-data.type';

export const LOAD_PERSISTANT = '[Cellar] Load persistant';
export const SET_DATA = '[Cellar] Set data';
export const REMOVE_DATA = '[Cellar] Remove data';
export const RESET = '[Cellar] Reset state';

export const loadPersistantCellar: any = createAction(LOAD_PERSISTANT);

export const setData: any = createAction(
  SET_DATA,
  props<{ data: Record<string, CellarData>; persistant?: boolean }>(),
);

export const removeData: any = createAction(REMOVE_DATA, props<{ key: string }>());

export const resetCellar: any = createAction(RESET);
